import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";

import "antd/dist/antd.css"; // or 'antd/dist/antd.less'

import Notfound from "./notfound";
import HomePage from "./Pages/HomePage";
import LoginPage from "./Pages/LoginPage";
import RafflePage from "./Pages/RafflePage";
import AddLatestArticlePage from "./Pages/AddLatestArticlePage";
import ElectionPage from "./Pages/ElectionPage";
import AddState from "./Pages/AddStateCollection";
import AppThemConfigPage from "./Pages/AppThemConfigPage";

import "antd/dist/antd.css";

const routing = (
  <Router>
    <Switch>
      <Route exact path="/" component={LoginPage} />
      <Route exact path="/dashboard" component={HomePage} />
      <Route exact path="/raffle" component={RafflePage} />
      <Route
        exact
        path="/add-latest-article"
        component={AddLatestArticlePage}
      />
      <Route exact path="/add-election-details" component={ElectionPage} />
      <Route exact path="/add-state" component={AddState} />
      <Route exact path="/app-config"  component={AppThemConfigPage} />
      <Route component={Notfound} />
    </Switch>
  </Router>
);

ReactDOM.render(routing, document.getElementById("root"));
